// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"6ab616bd","192":"a2d79fa9","410":"683a6b61","655":"771b2912","880":"7c7c8103","912":"d96a377d"}[chunkId] + ".chunk.js";
};